import { IInviteLinkProviderProps } from './interfaces';
import { ControllerFlowAPI } from 'yoshi-flow-editor-runtime/build/cjs/flow-api/ViewerScript';
import { getInvitationLink } from '../../selectors/getInvitationLink';
import { getChallengeId } from '../ChallengeDataProvider/challengeDataProviderPropsMap';
import { isMockedChallenge } from '../main/getMockedChallenges';

export async function inviteLinkPropsMap(
  flowAPI: ControllerFlowAPI,
): Promise<IInviteLinkProviderProps> {
  const { isEditor } = flowAPI.environment;
  const challengeId = await getChallengeId(flowAPI);

  if (isMockedChallenge(challengeId, flowAPI)) {
    return {
      inviteLink: '',
    };
  }

  try {
    const inviteLink = isEditor
      ? ''
      : await getInvitationLink(
          challengeId,
          flowAPI.controllerConfig.platformAPIs.bi.metaSiteId,
        );

    return {
      inviteLink,
    };
  } catch (error) {
    console.error(error);
  }

  return {
    inviteLink: '',
  };
}
